document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  document.querySelectorAll('details[open].bk-mobile-nav').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

document.querySelectorAll('[data-subscription-builder]').forEach((builder) => {
  const output = builder.querySelector('[data-plan-summary]');
  const planImage = builder.querySelector('[data-plan-image]');
  const planRoast = builder.querySelector('[data-plan-roast]');
  const planDeck = builder.querySelector('[data-plan-deck]');
  const planCount = builder.querySelector('[data-plan-count]');
  const planProgress = builder.querySelector('.bk-plan-progress span');
  const addButton = builder.querySelector('[data-plan-add]');
  const addButtonLabel = builder.querySelector('[data-plan-button-label]');
  const planPrice = builder.querySelector('[data-plan-price]');
  const planStatus = builder.querySelector('[data-plan-status]');
  const mobilePlan = builder.querySelector('[data-mobile-plan]');
  const detailFieldset = builder.querySelector('[data-plan-group="roast-detail"]');
  const roastFieldset = builder.querySelector('[data-plan-group="roast"]');
  const root = `${builder.dataset.cartRoot || '/'}`.replace(/\/?$/, '/');
  const currency = builder.dataset.currency || 'USD';
  const productCache = new Map();
  let activePlan = null;
  let resolveVersion = 0;
  let adding = false;
  const readSelection = (name) => builder.querySelector(`input[name="${name}"]:checked`);
  const normalize = (value) => `${value || ''}`.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  const setStatus = (message, state = 'checking') => {
    if (planStatus) {
      planStatus.textContent = message;
      planStatus.dataset.state = state;
    }
    if (planProgress) planProgress.textContent = state === 'ready' ? 'Live plan ready' : state === 'error' ? 'Needs adjustment' : 'Checking live plan';
  };
  const setButton = ({ disabled = true, label = 'Add subscription to bag', price = '' } = {}) => {
    if (addButton) addButton.disabled = disabled || adding;
    if (addButtonLabel) addButtonLabel.textContent = label;
    if (planPrice) planPrice.textContent = price;
  };

  if (detailFieldset && roastFieldset) roastFieldset.after(detailFieldset);

  const setGroupState = () => {
    const type = readSelection('coffee-type')?.value || 'Whole bean';
    const caffeine = readSelection('caffeine')?.value || 'Regular';

    const roastOptions = roastFieldset?.querySelectorAll('[data-roast-caffeine]') || [];
    roastOptions.forEach((option) => {
      const input = option.querySelector('input');
      const supportsFormat = input.value !== 'Coffees of the World' || type !== 'Bakri Cups';
      const visible = option.dataset.roastCaffeine === normalize(caffeine) && supportsFormat;
      option.hidden = !visible;
      input.disabled = !visible;
    });
    const visibleRoasts = Array.from(roastOptions).map((option) => option.querySelector('input')).filter((input) => !input.disabled);
    if (!visibleRoasts.some((input) => input.checked) && visibleRoasts[0]) visibleRoasts[0].checked = true;
    const roast = readSelection('roast')?.value || 'Colombian';

    const grindFieldset = builder.querySelector('[data-plan-group="grind"]');
    const grindGrid = grindFieldset?.querySelector('.bk-option-grid');
    const grindSkip = grindFieldset?.querySelector('[data-plan-skip]');
    const grindInputs = grindFieldset?.querySelectorAll('input') || [];
    const showGrindStep = type === 'Ground';
    const fixedGrind = roast === 'Turkish' || roast === 'Coffees of the World';
    const needsGrind = type === 'Ground' && !fixedGrind;
    if (grindFieldset) grindFieldset.hidden = !showGrindStep;
    if (grindGrid) grindGrid.hidden = !needsGrind;
    if (grindSkip) {
      grindSkip.hidden = !showGrindStep || needsGrind;
      const value = grindSkip.querySelector('[data-plan-skip-value]');
      const copy = grindSkip.querySelector('[data-plan-skip-copy]');
      if (value) value.textContent = roast === 'Coffees of the World' ? 'Sampler grind' : 'Turkish fine';
      if (copy) copy.textContent = roast === 'Coffees of the World' ? 'The sampler uses Bakri’s balanced all-purpose grind.' : 'Bakri Turkish coffee uses its traditional fixed fine grind.';
    }
    grindInputs.forEach((input) => {
      const decafMethods = ['Drip machine', 'Pour over', 'AeroPress', 'Regular grind'];
      const supported = caffeine === 'Decaf' ? decafMethods.includes(input.value) : (input.value !== 'Espresso' || roast === 'Espresso');
      const visible = needsGrind && supported;
      input.closest('.bk-option').hidden = !visible;
      input.disabled = !visible;
    });
    const visibleGrinds = Array.from(grindInputs).filter((input) => !input.disabled);
    if (!visibleGrinds.some((input) => input.checked) && visibleGrinds[0]) visibleGrinds[0].checked = true;

    const shipmentFieldset = builder.querySelector('[data-plan-group="shipment"]');
    const shipmentInputs = shipmentFieldset?.querySelectorAll('input') || [];
    shipmentInputs.forEach((input) => {
      const cupsChoice = input.value.includes('Bakri Cups');
      const samplerChoice = input.value === 'Sampler box';
      const visible = roast === 'Coffees of the World' ? samplerChoice : type === 'Bakri Cups' ? cupsChoice : !cupsChoice && !samplerChoice;
      input.closest('.bk-option').hidden = !visible;
      input.disabled = !visible;
    });
    const visibleShipment = Array.from(shipmentInputs).filter((input) => !input.disabled);
    if (!visibleShipment.some((input) => input.checked) && visibleShipment[0]) visibleShipment[0].checked = true;

    const detailKind = type !== 'Bakri Cups' && roast === 'Turkish' ? 'cardamom' :
      (type !== 'Bakri Cups' && roast === 'Espresso') || (type === 'Bakri Cups' && caffeine === 'Decaf') ? 'roast-style' : '';
    if (detailFieldset) detailFieldset.hidden = !detailKind;
    const detailInputs = detailFieldset?.querySelectorAll('input') || [];
    detailInputs.forEach((input) => {
      const option = input.closest('[data-detail-kind]');
      const visible = option?.dataset.detailKind === detailKind;
      option.hidden = !visible;
      input.disabled = !visible;
    });
    const visibleDetails = Array.from(detailInputs).filter((input) => !input.disabled);
    if (!visibleDetails.some((input) => input.checked) && visibleDetails[0]) visibleDetails[0].checked = true;

    Array.from(builder.querySelectorAll('.bk-sub-options > fieldset')).filter((fieldset) => !fieldset.hidden).forEach((fieldset, index) => {
      const step = fieldset.querySelector('legend > span');
      if (step) step.textContent = `${index + 1}`.padStart(2, '0');
    });

    return { type, caffeine, roast, detailKind };
  };

  const getProduct = async (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error('This coffee could not be loaded from Shopify.');
        return response.json();
      }));
    }
    return productCache.get(handle);
  };

  const findSellingPlan = (product, delivery) => {
    const weeks = Number((`${delivery}`.match(/\d+/) || [4])[0]);
    const plans = (product.selling_plan_groups || []).flatMap((group) => group.selling_plans || []);
    return plans.find((plan) => {
      const name = normalize(plan.name);
      if (weeks === 2) return name.includes('2 week') || name.includes('bi week') || name.includes('biweekly');
      if (weeks === 12) return name.includes('12 week') || name.includes('3 month');
      return name.includes('4 week') || name.includes('month') || name.includes('28 day');
    });
  };

  const findVariant = (product, selection) => {
    const cups = selection.type === 'Bakri Cups';
    const size = cups ? (selection.shipment.includes('12') ? '12' : '24') : (selection.shipment.includes('12') ? '12' : '20');
    const worldSampler = selection.roast === 'Coffees of the World';
    let candidates = worldSampler
      ? (product.variants || []).filter((variant) => variant.options.some((option) => normalize(option) === normalize(selection.type)))
      : (product.variants || []).filter((variant) => normalize(variant.options?.[0]).startsWith(size));
    if (cups) {
      const supreme = candidates.filter((variant) => variant.options.some((option) => normalize(option).includes('supreme')));
      if (supreme.length) candidates = supreme;
    } else if (!worldSampler) {
      let grind = 'whole bean';
      if (selection.type === 'Ground') {
        if (selection.roast === 'Turkish') grind = 'ground turkish style';
        else if (selection.grind === 'Espresso' && selection.roast === 'Espresso') grind = 'espresso grind';
        else if (selection.grind === 'French press' || selection.grind === 'Cold brew') grind = 'coarse';
        else grind = 'auto drip ground';
      }
      candidates = candidates.filter((variant) => variant.options.some((option) => normalize(option).includes(grind)));
    }
    if (selection.detail) {
      const detailed = candidates.filter((variant) => variant.options.some((option) => normalize(option) === normalize(selection.detail)));
      if (detailed.length) candidates = detailed;
    }
    return candidates[0] || null;
  };

  const resolvePlan = async (selection) => {
    const version = ++resolveVersion;
    activePlan = null;
    setButton({ disabled: true });
    setStatus('Checking Shopify for the exact variant, inventory, and recurring price…');
    const handle = selection.type === 'Bakri Cups' ? selection.roastInput?.dataset.cupHandle : selection.roastInput?.dataset.bagHandle;
    if (!handle) {
      setStatus('This roast does not have a purchasable subscription in Shopify yet.', 'error');
      return;
    }
    try {
      const product = await getProduct(handle);
      if (version !== resolveVersion) return;
      const variant = findVariant(product, selection);
      const sellingPlan = findSellingPlan(product, selection.delivery);
      if (!variant) throw new Error('That exact format is not available for this coffee. Try another grind or size.');
      if (!variant.available) throw new Error('That exact combination is currently sold out. Try another size or roast.');
      if (!sellingPlan) throw new Error(selection.roast === 'Coffees of the World' ? 'Coffees of the World is ready in the builder, but the Bakri Sampler Pack still needs a Shopify subscription plan.' : 'That delivery schedule is not enabled for this coffee yet.');
      const allocation = (variant.selling_plan_allocations || []).find((item) => `${item.selling_plan_id}` === `${sellingPlan.id}`);
      if (!allocation) throw new Error('That variant is not currently eligible for the selected subscription schedule.');
      activePlan = { product, variant, sellingPlan, selection, allocation };
      setButton({ disabled: false, price: formatMoney(allocation.price) });
      setStatus(`${product.title} · ${variant.title} · ${sellingPlan.name}`, 'ready');
    } catch (error) {
      if (version !== resolveVersion) return;
      setStatus(error.message || 'This plan could not be prepared. Please adjust the selections and try again.', 'error');
      setButton({ disabled: true });
    }
  };

  const sync = () => {
    const state = setGroupState();
    if (!output) return;
    const type = state.type;
    const roast = readSelection('roast');
    const shipment = readSelection('shipment')?.value || '20 oz bag';
    const delivery = readSelection('delivery')?.value || 'Every 4 weeks';
    const detail = detailFieldset?.hidden ? '' : (readSelection('roast-detail')?.value || '');
    const selections = [
      ['Coffee type', type],
      ...(type === 'Ground' ? [['Grind', state.roast === 'Turkish' ? 'Turkish fine' : state.roast === 'Coffees of the World' ? 'Sampler grind' : (readSelection('grind')?.value || 'Drip machine')]] : []),
      ['Caffeine', state.caffeine],
      ['Roast', roast?.value || 'Colombian'],
      ...(detail ? [['Roast detail', detail]] : []),
      ['Shipment', shipment],
      ['Delivery', delivery]
    ];
    output.innerHTML = selections.map(([label, value]) => `<div><span>${label}</span><b>${value}</b></div>`).join('');
    const typeInput = readSelection('coffee-type');
    const image = type === 'Bakri Cups' ? typeInput?.dataset.image : roast?.dataset.image;
    if (planImage && image) planImage.src = image;
    if (planRoast) planRoast.textContent = roast?.value || 'Colombian';
    if (planDeck) planDeck.textContent = `${shipment.includes('20 oz') ? 'About 50 cups' : shipment.includes('12 oz') ? 'About 30 cups' : shipment} · ${delivery.toLowerCase()}`;
    if (planCount) planCount.textContent = `${selections.length}/${selections.length}`;
    if (mobilePlan) mobilePlan.textContent = `${roast?.value || 'Colombian'} · ${shipment}`;
    resolvePlan({
      type,
      caffeine: state.caffeine,
      roast: roast?.value || 'Colombian',
      roastInput: roast,
      grind: type === 'Ground' ? (readSelection('grind')?.value || 'Drip machine') : '',
      detail,
      shipment,
      delivery
    });
  };

  builder.addEventListener('change', (event) => {
    sync();
    window.dispatchEvent(new CustomEvent('bakri:subscription-change', { detail: { group: event.target.dataset.label, value: event.target.value } }));
  });

  addButton?.addEventListener('click', async () => {
    if (!activePlan || adding) return;
    adding = true;
    setButton({ disabled: true, label: 'Adding subscription…', price: formatMoney(activePlan.allocation.price) });
    setStatus('Adding the configured recurring plan to your Shopify bag…');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: activePlan.variant.id, quantity: 1, selling_plan: activePlan.sellingPlan.id }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Shopify could not add this subscription.');
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((cartResponse) => cartResponse.json());
      document.querySelectorAll('.bk-cart-count').forEach((count) => { count.textContent = cart.item_count; });
      setStatus('Subscription added. Opening your bag…', 'ready');
      window.dispatchEvent(new CustomEvent('bakri:subscription-added', { detail: { variantId: activePlan.variant.id, sellingPlanId: activePlan.sellingPlan.id } }));
      window.location.assign(`${root}cart`);
    } catch (error) {
      adding = false;
      setStatus(error.message || 'The subscription could not be added. Please try again.', 'error');
      setButton({ disabled: false, label: 'Try adding again', price: formatMoney(activePlan.allocation.price) });
    }
  });

  sync();
});

document.querySelectorAll('[data-quantity]').forEach((control) => {
  const input = control.querySelector('input');
  control.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
    const next = Number(input.value || 1) + Number(button.dataset.delta);
    input.value = Math.max(1, next);
  }));
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variantSelect = root.querySelector('[data-variant-select]');
  const price = root.querySelector('[data-product-price]');
  const status = root.querySelector('[data-product-status]');
  const stock = root.querySelector('[data-stock-label]');
  const addButton = root.querySelector('[data-add-button]');
  const syncVariant = () => {
    if (!variantSelect) return;
    const option = variantSelect.options[variantSelect.selectedIndex];
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price;
    if (status) status.textContent = available ? 'Ready to order' : 'Currently sold out';
    if (stock) { stock.textContent = available ? 'Available' : 'Currently sold out'; stock.classList.toggle('is-sold-out', !available); }
    if (addButton) { addButton.disabled = !available; addButton.textContent = available ? `Add to bag · ${option.dataset.price}` : 'Sold out'; }
  };
  variantSelect?.addEventListener('change', syncVariant);
  syncVariant();

  const purchaseMode = root.querySelector('[data-purchase-mode]');
  const sellingPlan = root.querySelector('[data-selling-plan]');
  purchaseMode?.addEventListener('change', (event) => {
    if (!sellingPlan || event.target.name?.indexOf('purchase_mode_') !== 0) return;
    sellingPlan.disabled = event.target.value !== 'subscription';
  });
});

document.querySelectorAll('[data-collection-sort]').forEach((select) => select.addEventListener('change', () => select.form?.requestSubmit()));

document.querySelectorAll('[data-brew-signal]').forEach((matcher) => {
  const result = matcher.querySelector('[data-brew-result]');
  matcher.querySelectorAll('[data-brew-option]').forEach((button) => button.addEventListener('click', () => {
    matcher.querySelectorAll('[data-brew-option]').forEach((option) => {
      const active = option === button;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = option.querySelector('[data-brew-choice-label]');
      if (label) label.textContent = active ? 'Matched' : 'Match';
    });
    const roast = result?.querySelector('[data-brew-roast]');
    const detail = result?.querySelector('[data-brew-detail]');
    const temp = result?.querySelector('[data-brew-temp]');
    const time = result?.querySelector('[data-brew-time]');
    const image = result?.querySelector('[data-brew-image]');
    const link = result?.querySelector('[data-brew-link]');
    const price = result?.querySelector('[data-brew-price]');
    const step = result?.querySelector('[data-brew-step]');
    if (roast) roast.textContent = button.dataset.roast;
    if (detail) detail.textContent = button.dataset.detail;
    if (temp) temp.textContent = button.dataset.temp;
    if (time) time.textContent = button.dataset.time;
    if (image && button.dataset.productImage) {
      image.src = button.dataset.productImage;
      image.alt = button.dataset.roast;
    }
    if (link) link.href = button.dataset.productUrl || link.href;
    if (price) price.textContent = button.dataset.productPrice || '';
    if (step) step.textContent = `Match ${button.dataset.productIndex}`;
    result?.style.setProperty('--signal-color', button.dataset.color);
    result?.classList.remove('is-changing');
    window.requestAnimationFrame(() => result?.classList.add('is-changing'));
  }));
  const selected = matcher.querySelector('[data-brew-option].is-active');
  if (selected && result) result.style.setProperty('--signal-color', selected.dataset.color);
});

const bakriProfileUrls = new Map([
  ['Ford Road', 'https://www.google.com/maps?cid=14428015482537265174'],
  ['Café & Bakery', 'https://www.google.com/maps?cid=16580883789192621149'],
  ['Sterling Heights', 'https://www.google.com/maps?cid=724890256480267755']
]);

document.querySelectorAll('.bk-location-card').forEach((card) => {
  const locationName = card.querySelector('h3')?.textContent.trim();
  const profileUrl = bakriProfileUrls.get(locationName);
  if (!profileUrl) return;
  if (locationName === 'Sterling Heights') {
    const address = card.querySelector('h3 + p');
    if (address) address.innerHTML = '36839 Ryan Rd<br>Sterling Heights, MI 48310';
  }
  const directions = card.querySelector('.bk-location-directions');
  if (directions) {
    directions.href = profileUrl;
    directions.textContent = 'Directions ↗';
  }
});

document.addEventListener('submit', (event) => {
  if (event.target.matches('.bk-product-form,.bk-quick-add')) window.dispatchEvent(new CustomEvent('bakri:add-to-cart-intent', { detail: { formId: event.target.id || null } }));
  if (event.target.matches('[data-collection-filters]')) window.dispatchEvent(new CustomEvent('bakri:collection-filter'));
  if (event.target.matches('.bk-form')) window.dispatchEvent(new CustomEvent('bakri:lead-submit'));
});
